import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import {
    FormsModule
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { RegisterService } from 'app/services/register.service';
import { NavigationFlowService } from 'app/services/navigation-flow.service';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-emailverify-step',
  templateUrl: './email_verify_window.component.html',
  imports: [
    TranslocoPipe,
    FormsModule,
    MatIconModule,
    CommonModule
  ],
})
export class EmailVerifyStepComponent {
  @Output() next = new EventEmitter<void>();
  isLoading = false;
  email = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translocoService: TranslocoService,
    private _dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private dialogUtilsService: DialogUtilsService,
    private registerAuth: RegisterService,
    private navigationFlow: NavigationFlowService
  ) {
     this.email = data?.email || '';

  }
    
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  ngOnInit(): void{
    const formData = {
      email: this.email
    };
    this.registerAuth.sendVerificationEmail(formData).subscribe({
        next: (response) => {
          
        },
        error: (error) => {
         
        }
      });

  }
  continue() {
    if (this.email) this.next.emit();
  }
  async closeDialog(): Promise<void> {
    console.log('[EMAIL-VERIFY] closeDialog called');
    
    // Check if we have the global method available
    if (typeof (window as any).transitionToLogin === 'function') {
      console.log('[EMAIL-VERIFY] Using global transitionToLogin method');
      await (window as any).transitionToLogin();
    } else {
      console.warn('[EMAIL-VERIFY] Global transitionToLogin not available, using fallback');
      
      // Fallback: close current dialog and try to close parent
      if (this._dialogRef) {
        console.log('[EMAIL-VERIFY] Closing current dialog');
        this._dialogRef.close();
      }

      // Close remaining dialogs
      const remainingDialogs = this._dialog.openDialogs;
      console.log('[EMAIL-VERIFY] Remaining dialogs:', remainingDialogs.length);
      
      if (remainingDialogs && remainingDialogs.length > 0) {
        remainingDialogs.forEach(dialog => {
          console.log('[EMAIL-VERIFY] Closing dialog');
          dialog.close({ action: 'openLogin', email: this.email });
        });
      }
    }
  }

  sendEmailAgain(): void{
    const formData = {
      email: this.email
    };
    this.registerAuth.sendVerificationEmail(formData).subscribe({
        next: (response) => {
          
        },
        error: (error) => {
        }
      });
      
  }
  shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
  
  async openRegisterDialog(): Promise<void> {
    // Use NavigationFlowService to open login dialog
    await firstValueFrom(this.navigationFlow.openLoginDialog());
  }
}